// extracted by mini-css-extract-plugin
export default {"lead-amount-card":"style_lead-amount-card__qy4Qk","carousel":"style_carousel__DDIcD","chunk":"style_chunk__D0FPo"};